import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSnapshot } from 'valtio';
import { HistoryStore } from '@/utils/store/store';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';
import CommonLoading from '@/components/CommonLoading';
import HistoryList from '@/pages/Index/HistoryList';
import SidebarFoot from './SidebarFoot';
import Note from "@/pages/Index/static/Note.png";
import more from "@/pages/Index/static/more.png";
import {Empty} from "antd";
import SBApp from './SBApp';

/**
 * 左侧边栏组件，包含导航和历史记录
 */
const Sidebar: React.FC = () => {
    // 只使用 Supabase 认证状态
    const supabaseAuth = useSnapshot(supabaseAuthStore);
    const { data: historyData, runFetch, isLoading } = useSnapshot(HistoryStore);

    useEffect(() => {
        if (supabaseAuth.isAuthenticated && supabaseAuth.id) {
            runFetch(supabaseAuth.id);
        }
    }, [supabaseAuth.isAuthenticated, supabaseAuth.id, runFetch]);



    const historyLoading = supabaseAuth.isLoading || isLoading;

    const isEmpty = historyData
        &&  historyData[0].length === 0
        &&  historyData[1].length === 0
        &&  historyData[2].length === 0;

    useEffect(() => {

    }, [historyLoading,isEmpty]);

    return (
        <div className="flex-none responsive-sidebar bg-white h-full flex flex-col">


            <div className='p-5 pt-7 pb-2'>
                <div className=" flex font-inter">
                        <div className="text-[19px] font-medium text-black ">NivoWork</div>
                        <div className="text-[8px] font-medium bg-black text-white rounded-md w-7 h-3 mt-1 flex items-center justify-center ">Beta</div>
                    </div>
            </div>
            {/* <SBApp/> */}

            {/* 历史记录区域 */}
            <div className="flex-1 p-5 overflow-y-auto">
                <div className="text-[12px] space-y-2 font-normal font-inter">
                    {/* 记录标题和提示 */}
                    <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-1">
                            <img
                              src={Note}
                              className="w-5 h-5"
                            />
                            <div className="text-[14px]  text-black ">记录</div>
                        </div>
                        {/*<img*/}
                        {/*  src={more}*/}
                        {/*  className="w-5 h-5"*/}
                        {/*/>*/}
                        {/*<div className="text-[14px] text-gray-500">开始整理记录~</div>*/}
                    </div>

                    {/* 分割线 */}
                    <div className="border-t border-gray-200 h-4 mt-5"></div>

                    {
                        isEmpty &&
                        (historyLoading ?
                            <div className="pt-50 pb-2"><CommonLoading /> </div>:
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="pt-50 pb-2" description="暂无" />)
                    }


                    {
                        !isEmpty &&
                        <div>
                            <div className="  mb-0">今天</div>
                            <div className="space-y-0">
                                {historyLoading ? (
                                    <CommonLoading />
                                ) : (
                                    <HistoryList
                                        timeIndex={0}
                                        userId={supabaseAuth.id || ''}
                                    />
                                )}
                            </div>

                            <div className=" text-black mb-0">前7天</div>
                            <div className="space-y-0 ">
                                {historyLoading ? (
                                    <CommonLoading />
                                ) : (
                                    <HistoryList
                                        timeIndex={1}
                                        userId={supabaseAuth.id || ''}
                                    />
                                )}
                            </div>

                            <div className=" text-black mb-0">前30天</div>
                            <div className="space-y-0">
                                {historyLoading ? (
                                    <CommonLoading />
                                ) : (
                                    <HistoryList
                                        timeIndex={2}
                                        userId={supabaseAuth.id || ''}
                                    />
                                )}
                            </div>
                        </div>
                    }
                </div>
            </div>
            
            {/* 底部用户信息区域 */}
            <SidebarFoot />
        </div>
    );
};

export default Sidebar;